'use strict';

module.exports = require('./umd/react-cool-draggable.production.min.js');
